import { createContext, useContext } from "react";
import AccountStore from "./AccountStore";
import LicensesStore from "./LicensesStore";

export class AppStore {
  public accountStore: AccountStore;
  public licensesStore: LicensesStore;

  constructor() {
    this.accountStore = new AccountStore(this);
    this.licensesStore = new LicensesStore(this);
  }
}

export const appStoreInstance = new AppStore();

export const AppStoreContext = createContext<AppStore>(appStoreInstance);

export const useAppStore = (): AppStore => {
  return useContext(AppStoreContext);
};
